"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var button_1 = require("../../buttons/button/button");

var panel_1 = require("../panel/panel");

var Dialog = function (_super) {
  __extends(Dialog, _super);

  function Dialog() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Dialog.prototype.render = function () {
    var isPrompt = this.props.type === 'prompt';
    var overlayViewStyle = isPrompt ? theme_pricing_system_1.pricingStyles.dialogPromptOverlayViewStyle : theme_pricing_system_1.pricingStyles.dialogDefaultOverlayViewStyle;
    var dialogViewStyle = isPrompt ? theme_pricing_system_1.pricingStyles.dialogPromptViewStyle : theme_pricing_system_1.pricingStyles.dialogDefaultViewStyle;
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(panel_1.Panel, {
      heading: this.props.title,
      viewStyle: [dialogViewStyle, this.props.viewStyle],
      headingTextStyle: theme_pricing_system_1.pricingStyles.dialogHeadingTextStyle
    }, react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.dialogContentViewStyle
    }, this.props.children), react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.dialogButtonContainerViewStyle
    }, this.renderButtons())), react_1.default.createElement(react_native_1.View, {
      style: overlayViewStyle
    }));
  };

  Dialog.prototype.renderButtons = function () {
    var buttons = this.props.buttons;
    return buttons.map(function (button, index) {
      return react_1.default.createElement(button_1.Button, {
        key: index,
        label: button.text,
        onPress: button.onPress,
        textStyle: button.type === 'close' ? theme_pricing_system_1.pricingStyles.dialogButtonCloseTextStyle : theme_pricing_system_1.pricingStyles.dialogButtonDefaultTextStyle,
        viewStyle: button.type === 'close' ? theme_pricing_system_1.pricingStyles.dialogButtonCloseViewStyle : theme_pricing_system_1.pricingStyles.dialogButtonDefaultViewStyle
      });
    });
  };

  return Dialog;
}(react_1.default.Component);

exports.Dialog = Dialog;